(function () {
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2381"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2381"] = parcelRequire;
}

var $2a0T1 = parcelRequire("2a0T1");
function $53745877707b1859$export$4cf11838cdc2a8a8(unsafe) {
    return unsafe.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
}
function $53745877707b1859$export$1c8eb2e1a51a6a08(form) {
    const formMessage = document.querySelector(".form-message");
    formMessage.classList.add("success");
    formMessage.style.display = "block";
    if (form === "newsletter") formMessage.textContent = "You're signed up!";
    if (form === "contact") formMessage.textContent = "Your message has been successfully sent!";
    setTimeout(()=>{
        formMessage.style.display = "none";
        formMessage.textContent = "";
    }, 5000);
}


const $1397c3b7b48b05dd$var$email_regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
function $1397c3b7b48b05dd$export$2719e20cfdd3a977(fname) {
    if (fname.trim() === "") {
        document.querySelector(".form-control--fname").classList.add("error");
        document.querySelector(".form-control--fname .feedback").textContent = "Please enter your first name.";
        return false;
    }
    document.querySelector(".form-control--fname").classList.remove("error");
    return true;
}
function $1397c3b7b48b05dd$export$24ecae3988e349e5(lname) {
    if (lname.trim() === "") {
        document.querySelector(".form-control--lname").classList.add("error");
        document.querySelector(".form-control--lname .feedback").textContent = "Please enter your last name.";
        return false;
    }
    document.querySelector(".form-control--lname").classList.remove("error");
    return true;
}
function $1397c3b7b48b05dd$export$18148d12c805c5b0(email) {
    if (email.trim() === "") {
        document.querySelector(".form-control--email").classList.add("error");
        document.querySelector(".form-control--email .feedback").textContent = "Please enter your email address";
        return false;
    }
    if ($1397c3b7b48b05dd$var$email_regex.test(email) === false) {
        document.querySelector(".form-control--email").classList.add("error");
        document.querySelector(".form-control--email .feedback").textContent = "Please enter a valid email address";
        return false;
    }
    document.querySelector(".form-control--email").classList.remove("error");
    return true;
}
function $1397c3b7b48b05dd$export$c17861b159b1b673(message) {
    if (message.trim() === "") {
        document.querySelector(".form-control--message").classList.add("error");
        document.querySelector(".form-control--message .feedback").textContent = "Please enter a message";
        return false;
    }
    document.querySelector(".form-control--message").classList.remove("error");
    return true;
}


if (null) null.accept();
function $54966516d02dcf5c$var$init() {
    // initCursor();
    (0, $2a0T1.initNav)();
}
window.addEventListener("load", function() {
    $54966516d02dcf5c$var$init();
});
const $54966516d02dcf5c$var$form = document.querySelector("#contactForm");
const $54966516d02dcf5c$var$submitButton = document.querySelector("#submitButton");
const $54966516d02dcf5c$var$firstName = document.querySelector("#fname");
const $54966516d02dcf5c$var$lastName = document.querySelector("#lname");
const $54966516d02dcf5c$var$email_address = document.querySelector("input#email");
const $54966516d02dcf5c$var$message = document.querySelector("#message");
const $54966516d02dcf5c$var$notes = document.querySelector("input#notes");
async function $54966516d02dcf5c$var$submitForm() {
    $54966516d02dcf5c$var$submitButton.disabled = true;
    const firstNameIsValid = (0, $1397c3b7b48b05dd$export$2719e20cfdd3a977)($54966516d02dcf5c$var$firstName.value);
    const lastNameIsValid = (0, $1397c3b7b48b05dd$export$24ecae3988e349e5)($54966516d02dcf5c$var$lastName.value);
    const emailIsValid = (0, $1397c3b7b48b05dd$export$18148d12c805c5b0)($54966516d02dcf5c$var$email_address.value);
    const messageIsValid = (0, $1397c3b7b48b05dd$export$c17861b159b1b673)($54966516d02dcf5c$var$message.value);
    const notesIsValid = $54966516d02dcf5c$var$notes.value === "";
    const formData = new FormData($54966516d02dcf5c$var$form);
    if (firstNameIsValid === false || lastNameIsValid === false || emailIsValid === false || messageIsValid === false || notesIsValid === false) {
        console.log("failed");
        $54966516d02dcf5c$var$submitButton.disabled = false;
        return;
    }
    try {
        const response = await fetch("/", {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            body: new URLSearchParams(formData).toString()
        });
        if (response.ok) (0, $53745877707b1859$export$1c8eb2e1a51a6a08)("contact");
    } catch (error) {
        console.error(error);
        return;
    }
    $54966516d02dcf5c$var$form.reset();
    $54966516d02dcf5c$var$submitButton.disabled = false;
}
//-----------EVENT LISTENERS----------------------
$54966516d02dcf5c$var$form.addEventListener("submit", function(e) {
    e.preventDefault();
    $54966516d02dcf5c$var$submitForm();
});
$54966516d02dcf5c$var$firstName.addEventListener("blur", function() {
    (0, $1397c3b7b48b05dd$export$2719e20cfdd3a977)($54966516d02dcf5c$var$firstName.value);
});
$54966516d02dcf5c$var$lastName.addEventListener("blur", function() {
    (0, $1397c3b7b48b05dd$export$24ecae3988e349e5)($54966516d02dcf5c$var$lastName.value);
});
$54966516d02dcf5c$var$email_address.addEventListener("blur", function() {
    (0, $1397c3b7b48b05dd$export$18148d12c805c5b0)($54966516d02dcf5c$var$email_address.value);
});
$54966516d02dcf5c$var$message.addEventListener("blur", function() {
    (0, $1397c3b7b48b05dd$export$c17861b159b1b673)($54966516d02dcf5c$var$message.value);
});
//-----------FUNCTIONS----------------------
function $54966516d02dcf5c$var$displaySuccessMessage() {}

})();
//# sourceMappingURL=contact.584a22d5.js.map
